import React, { useEffect, useState } from 'react';
import { FileText, MessageCircle, Send, X } from 'lucide-react';
import { registerShareHost } from '../lib/waShare';

const Btn = ({ children, className = '', ...p }) => (
  <button type="button" className={`inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${className}`} {...p}>{children}</button>
);

export const WhatsAppShareHost = () => {
  const [job, setJob] = useState(null);
  const [note, setNote] = useState('');
  useEffect(() => { registerShareHost((j) => { setNote(''); setJob(j); }); return () => registerShareHost(null); }, []);
  if (!job) return null;
  const close = () => setJob(null);
  const k = job.kind || 'PDF';
  const openChat = () => { window.open(job.url, '_blank', 'noopener'); close(); };

  // Must run straight from the tap: no await before navigator.share.
  const share = () => {
    navigator.share({ files: [job.file], title: job.title, text: job.message })
      .then(close)
      .catch((e) => { if (e?.name !== 'AbortError') setNote('Sharing was blocked. Use "Send message only" instead.'); });
    navigator.clipboard?.writeText(job.message).catch(() => {});
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4" data-testid="wa-share-dialog">
      <div className="w-full max-w-md rounded-t-2xl bg-white p-5 shadow-2xl sm:rounded-2xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-base font-semibold text-slate-900">{job.mode === 'share' ? `${k} ready to share` : job.file ? `${k} downloaded` : `${k} unavailable`}</h3>
            {job.file && <p className="mt-1 flex items-center gap-1.5 text-xs text-slate-500" data-testid="wa-share-filename"><FileText size={14} /> {job.file.name}</p>}
          </div>
          <button type="button" onClick={close} className="rounded-lg p-1 text-slate-500 hover:bg-slate-100" data-testid="wa-share-close"><X size={18} /></button>
        </div>
        <p className="mt-3 text-sm text-slate-600" data-testid="wa-share-hint">
          {job.mode === 'share'
            ? `Tap Share on WhatsApp and pick WhatsApp. The ${k} goes with the message, which is also copied so you can paste it as the caption if WhatsApp drops it.`
            : job.file
              ? `The ${k} is in your Downloads. Open the chat, then drag the ${k} into it (or use the + / clip button) before you send.`
              : `The ${k} could not be prepared. You can still send the message.`}
        </p>
        <div className="mt-4 space-y-2">
          {job.mode === 'share' && <Btn onClick={share} className="bg-emerald-600 text-white hover:bg-emerald-700" data-testid="wa-share-file-btn"><Send size={16} /> Share on WhatsApp</Btn>}
          <Btn onClick={openChat} className={job.mode === 'share' ? 'border border-slate-200 text-slate-700 hover:bg-slate-50' : 'bg-emerald-600 text-white hover:bg-emerald-700'} data-testid="wa-share-open-chat-btn">
            <MessageCircle size={16} /> {job.mode === 'share' ? 'Send message only' : 'Open WhatsApp chat'}
          </Btn>
        </div>
        {note && <p className="mt-3 text-xs text-rose-600" data-testid="wa-share-note">{note}</p>}
      </div>
    </div>
  );
};
